import { datadogLogs } from "@datadog/browser-logs";
import pino from "pino";
const CX_PREFIX = "CX-Logger:";
const CONTACT_TOOLING = "Unexpected error occurred. Contact Cx-Tooling team.";
const DD_DISABLED = "Datadog Browser logs will not be initialized.";
const cxLog = {
  log: function(message) {
    console.log(`${CX_PREFIX} ${message}`);
  },
  warn: function(message) {
    console.warn(`${CX_PREFIX} ${message}`);
  },
  error: function(message, err) {
    console.error(`${CX_PREFIX} ${message}`, ...err ? [err] : []);
  },
  datadogInvalidEnv: function(validEnvs, passedEnv) {
    const envWithQuotes = validEnvs.map((env) => `'${env}'`);
    throw new Error(
      `${CX_PREFIX} Invalid env '${passedEnv}'. Must be one of ${envWithQuotes.join(
        ", "
      )}. ${DD_DISABLED}`
    );
  },
  validLoggerLevels: function(validLevels2, passedLevel) {
    const levelsWithQuotes = validLevels2.map((level) => `'${level}'`);
    this.error(
      `${CX_PREFIX} Invalid level '${passedLevel}'. Must be one of ${levelsWithQuotes.join(
        ", "
      )}. ${DD_DISABLED}`
    );
  },
  missingDatadogProperties: function(missingProps) {
    const formattedMissingProps = missingProps.map((prop) => `'${prop}'`).join(", ");
    const propertyOrProperties = missingProps.length > 1 ? "properties" : "property";
    throw new Error(
      `${CX_PREFIX} Missing required Datadog ${propertyOrProperties}: ${formattedMissingProps}. ${DD_DISABLED}`
    );
  }
};
function initializeDatadogBrowserLogs(options) {
  const config = {
    ...options
  };
  try {
    datadogLogs.init(config);
  } catch (error) {
    cxLog.error("Datadog Browser Logs failed to initialize.", error);
  }
}
const fuzzyKeys = [
  "ssn",
  "social",
  "name",
  "dob",
  "birth",
  "phone",
  "tradelines",
  "credit",
  "address",
  "street",
  "city",
  "zip",
  "answers",
  "pass"
];
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var lodash_clonedeep = { exports: {} };
(function(module, exports) {
  var LARGE_ARRAY_SIZE = 200;
  var HASH_UNDEFINED = "__lodash_hash_undefined__";
  var MAX_SAFE_INTEGER = 9007199254740991;
  var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
  var reFlags = /\w*$/;
  var reIsHostCtor = /^\[object .+?Constructor\]$/;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
  var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf = typeof self == "object" && self && self.Object === Object && self;
  var root = freeGlobal || freeSelf || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  function addMapEntry(map, pair) {
    map.set(pair[0], pair[1]);
    return map;
  }
  function addSetEntry(set, value) {
    set.add(value);
    return set;
  }
  function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }
  function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }
  function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }
  function getValue(object, key) {
    return object == null ? void 0 : object[key];
  }
  function isHostObject(value) {
    var result = false;
    if (value != null && typeof value.toString != "function") {
      try {
        result = !!(value + "");
      } catch (e) {
      }
    }
    return result;
  }
  function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }
  var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
  var coreJsData = root["__core-js_shared__"];
  var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var funcToString = funcProto.toString;
  var hasOwnProperty = objectProto.hasOwnProperty;
  var objectToString = objectProto.toString;
  var reIsNative = RegExp(
    "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Buffer = moduleExports ? root.Buffer : void 0, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
  var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0, nativeKeys = overArg(Object.keys, Object);
  var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise2 = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
  var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
  var symbolProto = Symbol ? Symbol.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
  function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
  }
  function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
  }
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? void 0 : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : void 0;
  }
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
  }
  function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
    return this;
  }
  Hash.prototype.clear = hashClear;
  Hash.prototype["delete"] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;
  function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear() {
    this.__data__ = [];
  }
  function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    return true;
  }
  function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? void 0 : data[index][1];
  }
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }
  function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype["delete"] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;
  function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear() {
    this.__data__ = {
      "hash": new Hash(),
      "map": new (Map || ListCache)(),
      "string": new Hash()
    };
  }
  function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
  }
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }
  function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
  }
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype["delete"] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;
  function Stack(entries) {
    this.__data__ = new ListCache(entries);
  }
  function stackClear() {
    this.__data__ = new ListCache();
  }
  function stackDelete(key) {
    return this.__data__["delete"](key);
  }
  function stackGet(key) {
    return this.__data__.get(key);
  }
  function stackHas(key) {
    return this.__data__.has(key);
  }
  function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
      var pairs = cache.__data__;
      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        return this;
      }
      cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys(value, inherited) {
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
      object[key] = value;
    }
  }
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }
  function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
  }
  function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) {
      result = object ? customizer(value, key, object, stack) : customizer(value);
    }
    if (result !== void 0) {
      return result;
    }
    if (!isObject(value)) {
      return value;
    }
    var isArr = isArray(value);
    if (isArr) {
      result = initCloneArray(value);
      if (!isDeep) {
        return copyArray(value, result);
      }
    } else {
      var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
      if (isBuffer(value)) {
        return cloneBuffer(value, isDeep);
      }
      if (tag == objectTag || tag == argsTag || isFunc && !object) {
        if (isHostObject(value)) {
          return object ? value : {};
        }
        result = initCloneObject(isFunc ? {} : value);
        if (!isDeep) {
          return copySymbols(value, baseAssign(result, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }
        result = initCloneByTag(value, tag, baseClone, isDeep);
      }
    }
    stack || (stack = new Stack());
    var stacked = stack.get(value);
    if (stacked) {
      return stacked;
    }
    stack.set(value, result);
    if (!isArr) {
      var props = isFull ? getAllKeys(value) : keys(value);
    }
    arrayEach(props || value, function(subValue, key2) {
      if (props) {
        key2 = subValue;
        subValue = value[key2];
      }
      assignValue(result, key2, baseClone(subValue, isDeep, isFull, customizer, key2, value, stack));
    });
    return result;
  }
  function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
  }
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  function baseGetTag(value) {
    return objectToString.call(value);
  }
  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
  }
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
  }
  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }
  function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor());
  }
  function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
  }
  function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor());
  }
  function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
  }
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }
  function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while (++index < length) {
      var key = props[index];
      var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
      assignValue(object, key, newValue === void 0 ? source[key] : newValue);
    }
    return object;
  }
  function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
  }
  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
  }
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : void 0;
  }
  var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
  var getTag = baseGetTag;
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function(value) {
      var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : void 0;
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
      result.index = array.index;
      result.input = array.input;
    }
    return result;
  }
  function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
  }
  function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
      case arrayBufferTag:
        return cloneArrayBuffer(object);
      case boolTag:
      case dateTag:
        return new Ctor(+object);
      case dataViewTag:
        return cloneDataView(object, isDeep);
      case float32Tag:
      case float64Tag:
      case int8Tag:
      case int16Tag:
      case int32Tag:
      case uint8Tag:
      case uint8ClampedTag:
      case uint16Tag:
      case uint32Tag:
        return cloneTypedArray(object, isDeep);
      case mapTag:
        return cloneMap(object, isDeep, cloneFunc);
      case numberTag:
      case stringTag:
        return new Ctor(object);
      case regexpTag:
        return cloneRegExp(object);
      case setTag:
        return cloneSet(object, isDeep, cloneFunc);
      case symbolTag:
        return cloneSymbol(object);
    }
  }
  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }
  function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
  }
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {
      }
      try {
        return func + "";
      } catch (e) {
      }
    }
    return "";
  }
  function cloneDeep2(value) {
    return baseClone(value, true, true);
  }
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }
  function isArguments(value) {
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
  }
  var isArray = Array.isArray;
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }
  function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
  }
  var isBuffer = nativeIsBuffer || stubFalse;
  function isFunction(value) {
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
  }
  function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
  }
  function isObjectLike(value) {
    return !!value && typeof value == "object";
  }
  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  function stubArray() {
    return [];
  }
  function stubFalse() {
    return false;
  }
  module.exports = cloneDeep2;
})(lodash_clonedeep, lodash_clonedeep.exports);
const cloneDeep = lodash_clonedeep.exports;
const ssn = [new RegExp("(?<!\\d)\\d{3}-?\\d{2}-?\\d{4}(?!\\d)")];
const valueRegexes = [...ssn];
const defaultConfig = {
  keys: [],
  mask: "*****"
};
const sanitize = (data, config = defaultConfig) => {
  const { keys = defaultConfig.keys, mask = defaultConfig.mask } = config;
  let dataCopy = typeof data === "object" && data !== null ? cloneDeep(data) : data;
  if (data instanceof Error) {
    const errorCopy = Object.isFrozen(data) ? { ...data, message: data.message } : data;
    errorCopy.message = sanitize(errorCopy.message, config);
    return errorCopy;
  }
  if (Array.isArray(dataCopy)) {
    return dataCopy.map((item) => sanitize(item, { keys, mask }));
  }
  if (typeof dataCopy === "object" && dataCopy !== null) {
    for (const key in dataCopy) {
      if (Object.prototype.hasOwnProperty.call(dataCopy, key)) {
        if (keys.includes(key)) {
          dataCopy[key] = mask;
        } else if (fuzzyKeys.some((fuzzyKey) => key.toLowerCase().includes(fuzzyKey))) {
          dataCopy[key] = mask;
        } else {
          dataCopy[key] = sanitize(dataCopy[key], { keys, mask });
        }
      }
    }
  }
  if (typeof dataCopy === "string" || typeof dataCopy === "number") {
    valueRegexes.forEach((regex) => {
      if (regex.test(dataCopy)) {
        if (typeof dataCopy === "string") {
          dataCopy = dataCopy.replace(regex, mask);
        }
        if (typeof dataCopy === "number") {
          dataCopy = mask;
        }
      }
    });
  }
  return dataCopy;
};
function parseEnvValue(input, defaultValue, optionName) {
  if (input === void 0) {
    return defaultValue;
  }
  if (input.toLowerCase() !== "true" && input.toLowerCase() !== "false") {
    throw new Error(
      `${CX_PREFIX} Invalid env input for '${optionName}': '${input}'. Expected 'true' or 'false'.`
    );
  }
  try {
    return input.toLowerCase() === "true";
  } catch (error) {
    throw new Error(`${CX_PREFIX} ${CONTACT_TOOLING}`);
  }
}
function configureOptionsFromEnvOrDefaults() {
  var _a, _b;
  return {
    logLevel: process.env.NEXT_PUBLIC_LOG_LEVEL || process.env.REACT_APP_LOG_LEVEL || "info",
    logLevelBrowser: process.env.NEXT_PUBLIC_LOG_LEVEL_BROWSER || process.env.REACT_APP_LOG_LEVEL_BROWSER || process.env.NEXT_PUBLIC_LOG_LEVEL || process.env.REACT_APP_LOG_LEVEL || process.env.NEXT_PUBLIC_LOG_LEVEL || process.env.REACT_APP_LOG_LEVEL || "info",
    logBrowserConsoleEnabled: parseEnvValue(
      process.env.NEXT_PUBLIC_LOG_BROWSER_CONSOLE_ENABLED || process.env.REACT_APP_LOG_BROWSER_CONSOLE_ENABLED,
      true,
      "LOG_BROWSER_CONSOLE_ENABLED"
    ),
    logPretty: parseEnvValue(
      process.env.NEXT_PUBLIC_LOG_PRETTY || process.env.REACT_APP_LOG_PRETTY,
      true,
      "LOG_PRETTY"
    ),
    logPrettyTimestampEnabled: parseEnvValue(
      process.env.NEXT_PUBLIC_LOG_PRETTY_IGNORE_TIME || process.env.REACT_APP_LOG_PRETTY_IGNORE_TIME,
      true,
      "LOG_PRETTY_IGNORE_TIME"
    ),
    logPrettySingleLine: parseEnvValue(
      process.env.NEXT_PUBLIC_LOG_PRETTY_SINGLE_LINE || process.env.REACT_APP_LOG_PRETTY_SINGLE_LINE,
      true,
      "LOG_PRETTY_SINGLE_LINE"
    ),
    logPrettyTranslateTime: process.env.NEXT_PUBLIC_LOG_PRETTY_TRANSLATE_TIME || process.env.REACT_APP_LOG_PRETTY_TRANSLATE_TIME || "HH:MM:ss",
    logSanitizeKeys: ((_a = process.env.NEXT_PUBLIC_LOG_SANITIZE_KEYS) == null ? void 0 : _a.split(",")) || ((_b = process.env.REACT_APP_LOG_SANITIZE_KEYS) == null ? void 0 : _b.split(",")),
    logSanitizeMask: process.env.NEXT_PUBLIC_LOG_SANITIZE_MASK || process.env.REACT_APP_LOG_SANITIZE_MASK,
    useDefaultPinoParamOrder: parseEnvValue(
      process.env.NEXT_PUBLIC_USE_DEFAULT_PINO_PARAM_ORDER || process.env.REACT_APP_USE_DEFAULT_PINO_PARAM_ORDER,
      false,
      "USE_DEFAULT_PINO_PARAM_ORDER"
    )
  };
}
function warnInvalidArgsOrder(mergingObject, message, useDefaultPinoParamOrder) {
  if (useDefaultPinoParamOrder) {
    if (typeof mergingObject === "string") {
      cxLog.warn(
        `Invalid argument '${mergingObject}' of type "String" passed. If using default Pino parameter order (mergingObject, message) the first arg should be of type Object.`
      );
    }
    if (typeof message === "object" && message !== null) {
      cxLog.warn(
        `Invalid argument '${JSON.stringify(
          message
        )}' of type "Object" passed. If using default Pino parameter order (mergingObject, message) the second arg should be of type String.`
      );
    }
  } else {
    if (typeof mergingObject === "string" || typeof message === "object" && message !== null) {
      cxLog.warn(
        `Invalid arguments passed. When not using default Pino parameter order (mergingObject, message), the first arg should be of type String and the second arg should be of type Object.`
      );
    }
  }
}
function transformLogParams(inputArgs, method, sanitize2) {
  const { useDefaultPinoParamOrder } = configureOptionsFromEnvOrDefaults();
  const [message, mergingObject, interpolationValues] = determineOrder(
    inputArgs,
    useDefaultPinoParamOrder
  );
  if (!Boolean(message)) {
    cxLog.warn("Missing message argument");
  }
  warnInvalidArgsOrder(mergingObject, message, useDefaultPinoParamOrder);
  const finalArgs = sanitize2(
    filterArgs(
      processLogArguments(mergingObject, message, interpolationValues),
      !useDefaultPinoParamOrder
    )
  );
  method.apply(this, finalArgs);
}
function processLogArguments(mergingObject, message, interpolationValues) {
  if (mergingObject instanceof Error) {
    mergingObject = {
      error: mergingObject,
      message: mergingObject == null ? void 0 : mergingObject.message
    };
  }
  return [mergingObject, message, interpolationValues];
}
function determineOrder(inputArgs, defaultPinoParamOrder, isChildLoggerAndPinoParamOrderTrue) {
  if (defaultPinoParamOrder && !isChildLoggerAndPinoParamOrderTrue) {
    if (inputArgs.length === 3) {
      return [inputArgs[1], inputArgs[0], inputArgs[2]];
    }
    return [inputArgs[1], inputArgs[0]];
  }
  if (isChildLoggerAndPinoParamOrderTrue) {
    return [inputArgs[0]];
  }
  return [inputArgs[0], inputArgs[1]];
}
function filterArgs(args, shouldSlice) {
  if (!Array.isArray(args)) {
    return [];
  }
  const filteredArgs = args.filter(
    (arg) => arg !== void 0 && !(typeof arg === "object" && Object.keys(arg).length === 0)
  );
  return shouldSlice ? filteredArgs.slice(0, 2) : filteredArgs;
}
function transformSendApi(logEvent, useDefaultPinoParamOrder, isChildLogger) {
  const isChildLoggerAndPinoParamOrderTrue = isChildLogger && useDefaultPinoParamOrder && typeof logEvent.messages[0] === "string";
  const [message, messageData] = determineOrder(
    logEvent.messages,
    useDefaultPinoParamOrder,
    isChildLoggerAndPinoParamOrderTrue
  );
  if (!Boolean(message)) {
    cxLog.warn("Missing message argument");
  }
  !useDefaultPinoParamOrder && validateMessageParameter(logEvent == null ? void 0 : logEvent.messages);
  let mergingObject = messageData && determineMergingObject(messageData);
  if (isChildLogger) {
    const bindingData = logEvent.bindings[0];
    if (!Array.isArray(mergingObject)) {
      mergingObject = [mergingObject];
    }
    mergingObject = [Object.assign({}, ...mergingObject, bindingData)];
  }
  const finalArgs = [
    ...filterArgs([message], false),
    ...filterArgs(mergingObject, false)
  ];
  return finalArgs;
}
function determineMergingObject(data) {
  if (data.length === 0)
    return void 0;
  if (typeof data[0] === "string")
    return data;
  return [data];
}
function validateMessageParameter(inputArgs) {
  if (inputArgs.length >= 2 && (typeof inputArgs[0] !== "string" || inputArgs[0].trim() === "")) {
    cxLog.warn("Message parameter is required and must be a non-empty string.");
  }
}
function getMessageToCreateErrorInstanceOn(isErrorObjectWithKey, mergingObject) {
  var _a;
  if (isErrorObjectWithKey) {
    return (_a = mergingObject == null ? void 0 : mergingObject.error) == null ? void 0 : _a.message;
  }
  return (mergingObject == null ? void 0 : mergingObject.msg) || "";
}
function getStackToPass(isErrorObjectWithKey, mergingObject) {
  var _a;
  if (isErrorObjectWithKey && mergingObject.error) {
    return (_a = mergingObject == null ? void 0 : mergingObject.error) == null ? void 0 : _a.stack;
  }
  return (mergingObject == null ? void 0 : mergingObject.stack) || "";
}
function createPinoLogger(loggerOptions, isDatadogEnabled) {
  const defaultOptions = configureOptionsFromEnvOrDefaults();
  const useDefaultPinoParamOrder = defaultOptions.useDefaultPinoParamOrder;
  const options = { ...defaultOptions, ...loggerOptions };
  const {
    logLevel,
    logLevelBrowser,
    logBrowserConsoleEnabled,
    logPretty,
    logPrettyTimestampEnabled,
    logPrettySingleLine,
    logPrettyTranslateTime,
    logSanitizeKeys,
    logSanitizeMask
  } = options;
  const sanitize$1 = (data) => sanitize(data, { keys: logSanitizeKeys, mask: logSanitizeMask });
  const logger = pino({
    hooks: {
      logMethod: function(inputArgs, method) {
        transformLogParams.apply(this, [inputArgs, method, sanitize$1]);
      }
    },
    formatters: {
      level: (level) => {
        return { level };
      },
      bindings: (bindings) => ({ ...bindings, client: "Server" })
    },
    errorKey: "error",
    messageKey: "message",
    timestamp: logPretty,
    level: logLevel ? logLevel.toLowerCase() : "info",
    ...logPretty && {
      transport: {
        target: "pino-pretty",
        options: {
          colorize: true,
          translateTime: logPrettyTranslateTime,
          singleLine: logPrettySingleLine,
          messageFormat: "\x1B[35m({client})\x1B[0m \x1B[36m{message}\x1B[0m",
          ignore: `pid,hostname${!logPrettyTimestampEnabled ? ",time" : ""}`
        }
      }
    },
    browser: {
      ...!logBrowserConsoleEnabled && {
        write: () => {
        }
      },
      transmit: {
        ...logLevelBrowser ? { level: logLevelBrowser } : {},
        send(level, logEvent) {
          if (!isDatadogEnabled) {
            return;
          }
          const isChildLogger = (logEvent == null ? void 0 : logEvent.bindings) && logEvent.bindings.length > 0;
          const [message, mergingObject = {}] = sanitize$1(
            transformSendApi(
              logEvent,
              useDefaultPinoParamOrder,
              isChildLogger
            )
          ) || [];
          warnInvalidArgsOrder(
            mergingObject,
            message,
            useDefaultPinoParamOrder
          );
          const isErrorObjectWithKey = mergingObject == null ? void 0 : mergingObject.error;
          const isInstanceOfError = (mergingObject == null ? void 0 : mergingObject.type) === "Error" || isErrorObjectWithKey;
          const messageToCreateErrorInstanceOn = getMessageToCreateErrorInstanceOn(
            isErrorObjectWithKey,
            mergingObject
          );
          const errorStackToPass = getStackToPass(
            isErrorObjectWithKey,
            mergingObject
          );
          const mergingObjectIsAnErrorObject = (mergingObject == null ? void 0 : mergingObject.type) === "Error" && (mergingObject == null ? void 0 : mergingObject.stack);
          const modifiedError = new Error(messageToCreateErrorInstanceOn);
          modifiedError.stack = errorStackToPass;
          const { error, ...remainingMergingObject } = mergingObject;
          const commonProperties = {
            client: "Browser",
            ...isErrorObjectWithKey ? remainingMergingObject : mergingObjectIsAnErrorObject ? {} : mergingObject
          };
          try {
            if (isInstanceOfError) {
              datadogLogs.logger[logEvent.level.label](
                message,
                commonProperties,
                modifiedError
              );
            } else {
              datadogLogs.logger[logEvent.level.label](message, {
                client: "Browser",
                ...commonProperties
              });
            }
          } catch (error2) {
            cxLog.error("Browser.Transmit.Send", error2);
          }
        }
      }
    }
  });
  return logger;
}
const validLevels = [
  "fatal",
  "error",
  "warn",
  "info",
  "debug",
  "trace"
];
function validateLoggerProps(passedLoggerOptions) {
  const booleanOptionsToValidate = [
    { key: "logBrowserConsoleEnabled", expectedType: "boolean" },
    { key: "logPretty", expectedType: "boolean" },
    { key: "logPrettyTimestampEnabled", expectedType: "boolean" },
    { key: "logPrettySingleLine", expectedType: "boolean" }
  ];
  const stringOptionsToValidate = [
    { key: "logLevel", validValues: validLevels },
    { key: "logLevelBrowser", validValues: validLevels }
  ];
  for (const option of booleanOptionsToValidate) {
    const value = passedLoggerOptions[option.key];
    if (value !== void 0 && typeof value !== option.expectedType) {
      throw new Error(
        `${CX_PREFIX} ${option.key} should be a ${option.expectedType} value.`
      );
    }
  }
  for (const option of stringOptionsToValidate) {
    const value = passedLoggerOptions[option.key];
    if (value && !option.validValues.includes(value)) {
      const levelsWithQuotes = option.validValues.map((level) => `'${level}'`);
      throw new Error(
        `${CX_PREFIX} Invalid level for '${option.key}'. Must be one of ${levelsWithQuotes.join(", ")}.`
      );
    }
  }
}
function getDefaultDatadogOptionsFromEnv() {
  const env = process.env.NEXT_PUBLIC_DATADOG_ENV || process.env.NEXT_PUBLIC_ENVIRONMENT || process.env.NEXT_PUBLIC_ENV || process.env.NEXT_PUBLIC_APP_ENV || process.env.REACT_APP_PUBLIC_ENV || process.env.REACT_APP_APP_ENV;
  const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || process.env.REACT_APP_DATADOG_CLIENT_TOKEN || "";
  const service = process.env.NEXT_PUBLIC_DATADOG_SERVICE || process.env.NEXT_PUBLIC_APPLICATION_NAME || process.env.REACT_APP_DATADOG_SERVICE || process.env.REACT_APP_APPLICATION_NAME;
  const version = process.env.NEXT_PUBLIC_DATADOG_VERSION || process.env.NEXT_PUBLIC_APP_VERSION || process.env.REACT_APP_DATADOG_VERSION || process.env.REACT_APP_APP_VERSION;
  const forwardErrorsToLogs = parseEnvValue(
    process.env.NEXT_PUBLIC_DATADOG_FORWARD_ERRORS_TO_LOGS || process.env.REACT_APP_DATADOG_FORWARD_ERRORS_TO_LOGS,
    false,
    "DATADOG_FORWARD_ERRORS_TO_LOGS"
  );
  const consoleLogsValue = process.env.NEXT_PUBLIC_DATADOG_FORWARD_CONSOLE_LOGS || process.env.REACT_APP_DATADOG_FORWARD_CONSOLE_LOGS;
  const forwardConsoleLogs = consoleLogsValue === "all" ? "all" : consoleLogsValue ? consoleLogsValue.split(",") : void 0;
  return {
    clientToken,
    service,
    env,
    version,
    forwardErrorsToLogs,
    forwardConsoleLogs
  };
}
const REQUIRED_DATADOG_PROPS = ["clientToken", "service", "env"];
function validateDatadogProps(mergedDatadogOptions) {
  const { clientToken, service, env } = mergedDatadogOptions;
  const validEnvs = ["dev", "stg", "sbx", "prd"];
  const requiredDatadogProps = { clientToken, service, env };
  const allRequiredPropsAbsent = REQUIRED_DATADOG_PROPS.every(
    (prop) => !requiredDatadogProps[prop]
  );
  if (allRequiredPropsAbsent) {
    return false;
  }
  const hasValidEnv = env !== void 0 && validEnvs.includes(env);
  if (!hasValidEnv) {
    cxLog.datadogInvalidEnv(validEnvs, env);
  }
  const missingProps = Object.entries(requiredDatadogProps).filter(([key, value]) => key !== "env" && (value == null || value === "")).map(([key]) => key);
  if (missingProps.length > 0 && Object.entries(mergedDatadogOptions).length > 0) {
    cxLog.missingDatadogProperties(missingProps);
  }
  return mergedDatadogOptions;
}
function processOptions(datadogOptions, loggerOptions) {
  const defaultLoggerOptions = configureOptionsFromEnvOrDefaults();
  const defaultDatadogOptions = getDefaultDatadogOptionsFromEnv();
  const initialLoggerOptions = {
    ...defaultLoggerOptions,
    ...loggerOptions
  };
  const finalDatadogOptions = {
    ...defaultDatadogOptions,
    ...datadogOptions
  };
  const hasAllRequiredPropsPresent = REQUIRED_DATADOG_PROPS.every(
    (prop) => finalDatadogOptions[prop]
  );
  validateLoggerProps(initialLoggerOptions);
  validateDatadogProps(finalDatadogOptions);
  const finalLoggerOptions = hasAllRequiredPropsPresent ? {
    ...initialLoggerOptions,
    logPretty: false,
    logBrowserConsoleEnabled: false
  } : {
    ...initialLoggerOptions
  };
  return {
    finalDatadogOptions,
    finalLoggerOptions
  };
}
let loggerInstance;
function initializeLogger(datadogOptions, loggerOptions) {
  let isDatadogEnabled = false;
  const { finalDatadogOptions, finalLoggerOptions } = processOptions(
    datadogOptions,
    loggerOptions
  );
  if (validateDatadogProps(finalDatadogOptions)) {
    try {
      initializeDatadogBrowserLogs(finalDatadogOptions);
      isDatadogEnabled = true;
    } catch (error) {
      cxLog.error("Initialize DDBL error", error);
      isDatadogEnabled = false;
    }
  }
  loggerInstance = createPinoLogger(finalLoggerOptions, isDatadogEnabled);
}
const loggerProxy = new Proxy(
  {},
  {
    get(_target, prop) {
      if (!loggerInstance) {
        initializeLogger();
      }
      return loggerInstance[prop];
    }
  }
);
export {
  loggerProxy as default,
  initializeLogger
};
//# sourceMappingURL=index.es.js.map
